import {
    RECURRING_TRANSFER_FREQUENCY_DESCRIPTION_MAP,
    RecurringTransferFrequency as RecurringTransferFrequencyEnum,
} from '@fruitful/types';
import { useState } from 'react';
import { RadioInputRow, YStack } from 'smoothie';

interface RecurringTransferFrequencyProps {
    onSubmit: (frequency?: RecurringTransferFrequencyEnum) => void;
    frequency?: RecurringTransferFrequencyEnum;
}

const RecurringTransferFrequency = ({
    onSubmit,
    frequency,
}: RecurringTransferFrequencyProps) => {
    const [selectedFrequency, setSelectedFrequency] =
        useState<RecurringTransferFrequencyEnum | null>(frequency ?? null);

    return (
        <YStack width="100%">
            {[
                RecurringTransferFrequencyEnum.WEEKLY,
                RecurringTransferFrequencyEnum.FORTNIGHTLY,
                RecurringTransferFrequencyEnum.MONTHLY,
            ].map((freq) => (
                <RadioInputRow
                    key={freq}
                    label={RECURRING_TRANSFER_FREQUENCY_DESCRIPTION_MAP[freq]}
                    isSelected={freq === selectedFrequency}
                    onPress={() => {
                        setSelectedFrequency(selectedFrequency);
                        onSubmit(freq);
                    }}
                />
            ))}
        </YStack>
    );
};

export default RecurringTransferFrequency;
